export default __webpack_public_path__ + "static/media/LR.f68640f9.svg";